'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Icon, Text, useTranslation } from '@weareconceptstudio/core';
import { useState, useEffect, useRef } from 'react';
import { useScrollDirection } from '@/helpers/useScrollDirection';

//* Translations
import languagesModules from '@/translations/index';

//* Styles
import LanguageSwitcherStyle from './style';

const LanguageSwitcher = ({ className = '' }) => {
	const pathname = usePathname();
	const { selectedLang } = useTranslation();
	const [isOpen, setIsOpen] = useState(false);
	const [isTouch, setIsTouch] = useState(false);
	const wrapperRef = useRef(null);

	const isScrolled = useScrollDirection();

	useEffect(() => {
		if (window.matchMedia('(pointer: coarse)').matches) {
			setIsTouch(true);
		}
	}, []);

	useEffect(() => {
		if (!isOpen) return;

		function handleClickOutside(e) {
			if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
				setIsOpen(false);
			}
		}

		document.addEventListener('mousedown', handleClickOutside);
		document.addEventListener('touchstart', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
			document.removeEventListener('touchstart', handleClickOutside);
		};
	}, [isOpen]);

	const route = pathname.startsWith(`/${selectedLang}`) ? pathname.slice(selectedLang.length + 1) : pathname;

	const langArr = Object.keys(languagesModules);

	return (
		<LanguageSwitcherStyle
			ref={wrapperRef}
			className={`languages-switcher-wrapper ${!isScrolled ? 'hover-version' : ''} ${className} ${isOpen ? 'open' : ''}`}>
			<div
				className='selected-lang-wrap'
				onClick={() => isTouch && setIsOpen((prev) => !prev)}>
				<Text
					text={selectedLang}
					className='p2 black-1000 montserrat-400 capitalize selected-lang'
				/>
				<Icon
					name='arrow'
					className='black-1000 selected-lang-icon'
				/>
			</div>

			<div className='languages-wrapper'>
				<div className='languages-inner-wrapper'>
					{langArr.map(
						(lang) =>
							lang !== selectedLang && (
								<div
									key={lang}
									className='lang-item-block'>
									<Link
										href={`/${lang}${route}`}
										className='lang-item-link'
										onClick={() => setIsOpen(false)}>
										<Text
											className='p2 black-1000 montserrat-400 capitalize lang-item'
											text={lang}
										/>
									</Link>
								</div>
							)
					)}
				</div>
			</div>
		</LanguageSwitcherStyle>
	);
};

export default LanguageSwitcher;
